"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Chat_1 = __importDefault(require("./Chat"));
class NotificationAwareChat extends Chat_1.default {
    constructor(dateTimeProvider, identityService, chatRepository, customerNotifications) {
        super(dateTimeProvider, identityService, chatRepository);
        this.send = async (message, withMemberId) => {
            const messageId = await this.doSend(message, withMemberId);
            if (withMemberId) {
                await this.customerNotifications.clearCustomerNotifications(withMemberId);
            }
            return messageId;
        };
        this.customerNotifications = customerNotifications;
    }
}
exports.default = NotificationAwareChat;
//# sourceMappingURL=NotificationAwareChat.js.map